export default {
  FANTASY_CRICKET: 'CRICKET',
  FANTASY_FOOTBALL: 'FOOTBALL',
  FANTASY_KABADDI: 'KABADDI',
  FANTASY_SUBSTITUTION: 'SUBSTITUTION',
  FANTASY_YES_NO: 'YES_NO'
};
